export function hashCode(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;
  }
  return h;
}

export function createSequence(n: number): number[] {
  const arr = new Array<number>(n);
  for (let i = 0; i < n; i++) {
    arr[i] = i;
  }
  return arr;
}

export function tryDecodeUriComponent(s: string): string {
  try {
    return decodeURIComponent(s);
  } catch (e) {
    return unescape(s);
  }
}

export function extractQueryParams(query: string): Record<string, string> {
  const result: Record<string, string> = {};

  if (query[0] === '?') {
    query = query.substring(1);
    const splitted = query.split('&');
    splitted.forEach((s) => {
      const param = s.split('=');
      result[param[0]] = tryDecodeUriComponent(param[1]);
    });
  }
  return result;
}

export const encodeRFC3986URIComponent = (str: string): string =>
  encodeURIComponent(str).replace(
    /[!'()*]/g,
    (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`
  );
